import React from 'react';
import iconTg1 from '../icons/tg-1.svg';
import iconX1 from '../icons/x-1.svg';

const Footer = () => {

  return (
    <footer className="py-8 px-4" style={{ background: 'var(--section-bg)', color: 'var(--text-primary)' }}>
      <div className="max-w-7xl mx-auto">
        <p className="mt-2 text-md text-center mb-2 font-[500]">
          <span className='text-[#381606] font-bold'>Disclaimer: </span> Investing in tokens through this launchpad involves risk and may result in loss of your investment. We do not provide financial advice or guarantee any project’s success. Users must perform their own due diligence before participating.
        </p>
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <img
              src="/logo.png"
              className="h-16 w-auto footer-logo"
              alt="DogWifHair logo"
            />
            <p className="mt-2 text-sm">
              Empowering meme token creation without coding
            </p>
          </div>

          <div className="flex space-x-6">
            <a href="https://x.com/DogWifHair" target="_blank" rel="noopener noreferrer">
              <img src={iconX1} className="w-6 h-6 filter invert" alt="" />
            </a>
            <a href="https://t.me/dogwifhaircoin" target="_blank" rel="noopener noreferrer">
              <img src={iconTg1} className="w-6 h-6 filter invert" alt="" />
            </a>
          </div>
        </div>

        <div className="mt-8 text-center text-sm">
          <p>© 2025 DogWifHair. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
